(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleats-tiktok-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function paramSaysTikTok() {
    var params = new URLSearchParams(window.location.search);
    var src = (params.get('utm_source') || '').toLowerCase();
    return params.get('tt') === '1' || src === 'tiktok';
  }

  function startCountdown(popup) {
    var el = popup.querySelector('[data-tt-countdown]');
    if (!el) return;
    var end = new Date(el.getAttribute('data-ends')).getTime();
    var timeEl = el.querySelector('[data-tt-time]');

    function tick() {
      var diff = end - Date.now();
      if (isNaN(end) || diff <= 0) {
        el.hidden = true;
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timeEl.textContent = h + 'h ' + (m < 10 ? '0' : '') + m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    }

    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!paramSaysTikTok()) return;

    var popup = document.querySelector('.tt-popup');
    if (!popup || !popup.showModal) return;

    var seenKey = 'mirrorless.tt-popup.seen';
    if (sessionStorage.getItem(seenKey) === '1') return;

    startCountdown(popup);
    popup.showModal();
    try { sessionStorage.setItem(seenKey, '1'); } catch (e) {}
  });

  document.addEventListener('click', function (e) {
    var popup = e.target.closest && e.target.closest('.tt-popup');
    if (popup && (e.target === popup || e.target.closest('[data-tt-close]'))) popup.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-development"] && !Shopify.designMode) return;
  try {
    
(function () {
  function make(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  // Photo viewer inside a pop-up: swipe or use the arrows/dots, with a counter
  function initViewer(modal) {
    var viewer = modal.querySelector('[data-dev-viewer]');
    if (!viewer || viewer.__ready) return;
    viewer.__ready = true;

    var track = viewer.querySelector('.dev-viewer__track');
    var slides = track.querySelectorAll('.dev-viewer__slide');
    if (slides.length < 2) return;

    var stage = viewer.querySelector('.dev-viewer__stage');
    var dotRow = viewer.querySelector('[data-dev-dots]');
    var count = make('span', 'dev-viewer__count', '1 / ' + slides.length);
    var prev = make('button', 'dev-viewer__nav dev-viewer__nav--prev');
    var next = make('button', 'dev-viewer__nav dev-viewer__nav--next');
    prev.type = next.type = 'button';
    prev.setAttribute('aria-label', 'Previous photo');
    next.setAttribute('aria-label', 'Next photo');
    stage.appendChild(count);
    stage.appendChild(prev);
    stage.appendChild(next);

    var dots = Array.prototype.map.call(slides, function (s, i) {
      var d = make('button', 'dev-viewer__dot');
      d.type = 'button';
      d.setAttribute('aria-label', 'Photo ' + (i + 1));
      d.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
      dotRow.appendChild(d);
      return d;
    });

    function sync() {
      var w = track.clientWidth || 1;
      var i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
      count.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      prev.disabled = i === 0;
      next.disabled = i === slides.length - 1;
    }

    track.addEventListener('scroll', sync, { passive: true });
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    sync();
  }

  // Lock the page behind an open pop-up, and release it (with no focus ring left on the card) when it closes
  function initModal(modal) {
    if (modal.__devReady) return;
    modal.__devReady = true;

    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('dev-lock');
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    });

    // Touches on the dimmed backdrop shouldn't scroll the page underneath
    modal.addEventListener('touchmove', function (e) {
      if (e.target === modal) e.preventDefault();
    }, { passive: false });
  }

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal || !modal.showModal) return;
    initViewer(modal);
    initModal(modal);
    modal.scrollTop = 0;
    document.documentElement.classList.add('dev-lock');
    modal.showModal();
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-dev-open]');
    if (card) {
      openModal(card.getAttribute('data-dev-open'));
      return;
    }
    var modal = e.target.closest && e.target.closest('.dev-modal');
    if (modal && (e.target === modal || e.target.closest('[data-dev-close]'))) modal.close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest && e.target.closest('[data-dev-open]');
    if (card && e.target === card) {
      e.preventDefault();
      openModal(card.getAttribute('data-dev-open'));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('dev-form')) return;
    e.preventDefault();

    var msg = form.querySelector('.dev-form__msg');
    var btn = form.querySelector('.dev-form__submit');
    btn.disabled = true;

    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('bad response');
        form.querySelector('.dev-form__row').hidden = true;
        msg.textContent = "You're on the list. We'll email you as soon as there's news.";
        msg.hidden = false;
      })
      .catch(function () {
        btn.disabled = false;
        msg.textContent = 'Something went wrong. Please try again.';
        msg.hidden = false;
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
